<template>
    <div id="resetPassword">
        <patternlib-headline :headline="$t('resetPassword.headline')" heading-tag="h2" separator="none" />
        <p 
            v-html="$t('resetPassword.text')"
            style="margin-top: var(--spacing-6);"
        ></p>
        <div v-if="codeStatus == 'valid'">
            <newPassword ref="newPassword"/>
            <patternlib-button 
                style="margin-top: var(--spacing-6);"
                :label="$t('resetPassword.save')"
                :loading="loading"
                @click="resetPassword"
            />
        </div>

        <div v-if="codeStatus == 'expired'">
            <patternlib-alert-message 
            icon-name="warning" 
            type="error"
            style="margin-top: var(--spacing-6);"
            >
                {{ $t("resetPassword.expiredCodeText") }}
            </patternlib-alert-message>
            <patternlib-button
                type="secondary"
                :label="$t('passwordResetMailSent.backToLogin')"
                @click="() => {this.$router.push('/')}"
            />
        </div>

        <div v-if="codeStatus == 'checking'" style="display: flex; justify-content: center;">
            <patternlib-spinner
                spin
            />
        </div>
    </div>

</template>

<script>
import newPassword from "../components/newPassword.vue"
import { useServices } from "../services/useServices";

export default {
    data: () => ({
        codeStatus: "checking",
        loading: false,
        resetCode: null
    }),

    components: {
        newPassword
    },

    methods: {
        resetPassword() {
            this.loading=true
            const services = useServices()
            let newPassword = this.$refs.newPassword.getPassword()
            if (newPassword && this.resetCode) {
                services.$api.resetToNewPassword((successful) => {
                    if (successful){
                        this.$router.push("/")
                    }
                    this.loading=false
                }, this.resetCode, newPassword)
            }
        }
    },

    created() {
        const services = useServices()
        this.resetCode = this.$route.query.resetCode
        window.history.replaceState({}, document.title, window.location.origin + window.location.pathname + "#/resetPassword") // remove the querys of the url
        if (this.resetCode) {
            services.$api.isValidPasswordResetConformationCode((valid) => {
                this.codeStatus = valid ? "valid" : "expired"
            }, this.resetCode)
        }
        else {this.codeStatus = "expired"}
    }
}
</script>

<style lang="scss" scoped>
#resetPassword {
    margin: 64px;
}

</style>